// extracted by mini-css-extract-plugin
export default {"container":"LeaderAvatar_container__98qP9","image":"LeaderAvatar_image__Bz4mG"};